import { loadJSON } from './data-loader.js';

/* ─── SVG Icons ─────────────────────────────────────────── */
const ICONS = {
  linkedin: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>`,
  twitter: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.26 5.632L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z"/></svg>`,
  instagram: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>`,
  whatsapp: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>`,
  phone: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/></svg>`
};

function buildWhatsAppUrl(siteData) {
  if (!siteData.whatsapp || !siteData.whatsapp.enabled) return null;
  const num = siteData.whatsapp.number;
  const msg = encodeURIComponent(siteData.whatsapp.default_message || 'Hi Antiopix! I\'d like to discuss a project.');
  return `https://wa.me/${num}?text=${msg}`;
}

/* ─── Social Bar ─────────────────────────────────────────── */
export async function buildSocialBar() {
  const siteData = await loadJSON('/data/site.json');
  if (!siteData) return;

  const container = document.getElementById('social-bar-container');
  if (!container) return;

  const waUrl = buildWhatsAppUrl(siteData);
  const social = siteData.social || {};
  const phone = siteData.phone || {};

  const socialLinks = [
    social.linkedin && `<a href="${social.linkedin}" target="_blank" rel="noopener" aria-label="LinkedIn">${ICONS.linkedin}</a>`,
    social.twitter && `<a href="${social.twitter}" target="_blank" rel="noopener" aria-label="Twitter / X">${ICONS.twitter}</a>`,
    social.instagram && `<a href="${social.instagram}" target="_blank" rel="noopener" aria-label="Instagram">${ICONS.instagram}</a>`
  ].filter(Boolean).join('');

  const phoneHTML = phone.display_enabled && phone.number
    ? `<a class="social-bar-phone" href="tel:${phone.number.replace(/\s/g, '')}">${ICONS.phone} ${phone.number}</a>`
    : '';

  const waHTML = waUrl
    ? `<a class="social-bar-wa" href="${waUrl}" onclick="window.open(this.href, 'whatsapp', 'width=600,height=700'); return false;">
        ${ICONS.whatsapp}
        Chat on WhatsApp
       </a>`
    : '';

  container.innerHTML = `
    <div class="social-bar" id="social-bar">
      <div class="social-bar-icons">
        ${socialLinks}
        ${phoneHTML}
      </div>
      <div class="social-bar-right">
        ${waHTML}
      </div>
    </div>
  `;

  // Add scroll class to body for potential styling (e.g. shadow on nav)
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }
    },
    { threshold: 0 }
  );
  // Observe hero section once page renders
  setTimeout(() => {
    const hero = document.getElementById('hero-section') || document.querySelector('.hero');
    if (hero) observer.observe(hero);
  }, 300);
}

/* ─── Navigation ─────────────────────────────────────────── */
export async function buildNavigation() {
  const siteData = await loadJSON('/data/site.json');
  if (!siteData) return;

  const navContainer = document.getElementById('nav-container');
  if (!navContainer) return;
  const isDriveDomain = window.location.hostname.startsWith('drive.');

  const navHTML = `
    <nav id="main-nav">
      <div class="brand">
        <a href="/" style="display:flex; align-items:center; text-decoration:none; color:inherit; gap: 0.5rem;">
          ${siteData.brand.logo
      ? `<img src="${siteData.brand.logo}" alt="${siteData.brand.name}" style="height:60px; transform: scale(1.8); transform-origin: left center;">`
      : `<span style="font-family:'Space Grotesk',sans-serif;font-weight:700;font-size:1.3rem;">${siteData.brand.name}</span>`
    }
        </a>
      </div>
      <button class="mobile-menu-toggle" aria-label="Toggle navigation">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
        </svg>
      </button>
      <ul class="nav-links">
        ${siteData.navigation.map(link => `
          <li>
            <a href="${link.href}"
               ${link.external ? 'target="_blank" rel="noopener"' : ''}
               class="${link.isButton ? 'btn btn-primary glow-button' : ''}">
              ${link.label}
            </a>
          </li>
        `).join('')}
      </ul>
    </nav>
  `;
  navContainer.innerHTML = navHTML;

  // Bind mobile menu toggle
  const mobileToggle = navContainer.querySelector('.mobile-menu-toggle');
  const mainNav = navContainer.querySelector('#main-nav');
  if (mobileToggle && mainNav) {
    mobileToggle.addEventListener('click', () => {
      mainNav.classList.toggle('nav-open');
    });

    // Close menu when a link is clicked
    const navLinks = mainNav.querySelectorAll('.nav-links a');
    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        mainNav.classList.remove('nav-open');
      });
    });
  }
}

/* ─── Footer ─────────────────────────────────────────────── */
export async function buildFooter() {
  const siteData = await loadJSON('/data/site.json');
  if (!siteData) return;

  const footerContainer = document.getElementById('footer-container');
  if (!footerContainer) return;

  const isDriveDomain = window.location.hostname.startsWith('drive.');

  const social = siteData.social || {};
  const brand = siteData.brand || {};
  const footer = siteData.footer || {};
  const phone = siteData.phone || {};
  const waUrl = buildWhatsAppUrl(siteData);

  // On drive subdomain: minimal footer – just logo and tagline
  if (isDriveDomain) {
    footerContainer.innerHTML = `
      <footer style="z-index: 10; position: relative; width: 100%; border-top: 1px solid var(--border-subtle); background: var(--bg-glass); backdrop-filter: blur(14px); padding: 0.875rem 5%; display: flex; align-items: flex-end; justify-content: space-between; box-sizing: border-box; gap: 1rem; flex-wrap: wrap;">
        <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 0.25rem;">
          <a href="/" style="display:inline-flex; align-items:center; text-decoration:none; gap: 0.75rem;">
            ${brand.logo
              ? `<img src="${brand.logo}" alt="${brand.name}" style="height:32px; transform: scale(2.8); transform-origin: left center;">`
              : `<span style="font-family:'Space Grotesk',sans-serif;font-weight:700;font-size:1.1rem;color:var(--text-primary);">${brand.name}</span>`
            }
          </a>
          <span style="font-size: 0.8rem; color: var(--text-secondary); font-family: 'Inter', sans-serif; margin-left: 0.1rem;">${brand.tagline || 'All your clouds, one sky'}</span>
        </div>
        <div style="display:flex; gap:1.25rem; align-items:center; margin-bottom: 0.1rem;">
          <a href="#/privacy" style="font-size:0.75rem; color:var(--text-secondary); text-decoration:none; transition:color 0.2s;" onmouseover="this.style.color='var(--text-primary)'" onmouseout="this.style.color='var(--text-secondary)'">Privacy</a>
          <a href="#/terms" style="font-size:0.75rem; color:var(--text-secondary); text-decoration:none; transition:color 0.2s;" onmouseover="this.style.color='var(--text-primary)'" onmouseout="this.style.color='var(--text-secondary)'">Terms</a>
        </div>
      </footer>
    `;
    return;
  }

  const socialIconLinks = [
    social.linkedin && `<a href="${social.linkedin}" target="_blank" rel="noopener" class="footer-social-icon" aria-label="LinkedIn">${ICONS.linkedin}</a>`,
    social.twitter && `<a href="${social.twitter}" target="_blank" rel="noopener" class="footer-social-icon" aria-label="Twitter">${ICONS.twitter}</a>`,
    social.instagram && `<a href="${social.instagram}" target="_blank" rel="noopener" class="footer-social-icon" aria-label="Instagram">${ICONS.instagram}</a>`
  ].filter(Boolean).join('');

  const serviceLinks = (footer.services_links || [])
    .map(l => `<li><a href="${l.href}">${l.label}</a></li>`)
    .join('');

  const quickLinks = (footer.links || [])
    .map(l => `<li><a href="${l.href}">${l.label}</a></li>`)
    .join('');

  const contactItems = [
    phone.display_enabled && phone.number
      ? `<li><a href="tel:${phone.number.replace(/\s/g, '')}" style="display:flex;align-items:center;gap:0.4rem;">${ICONS.phone} ${phone.number}</a></li>`
      : ''
  ].filter(Boolean).join('');

  const privacyHref = '/privacy';
  const termsHref = '/terms';

  const footerHTML = `
    <footer>
      <div class="footer-grid">
        <div class="footer-brand">
          <a href="/" style="display:inline-block;text-decoration:none;">
            ${brand.logo
      ? `<img src="${brand.logo}" alt="${brand.name}" style="height:52px;">`
      : `<span style="font-family:'Space Grotesk',sans-serif;font-weight:700;font-size:1.3rem;color:var(--text-primary);">${brand.name}</span>`
    }
          </a>
          <p>${brand.tagline || 'Simplifying digital life'}</p>
          <div class="footer-social-icons">${socialIconLinks}</div>
        </div>
        ${serviceLinks ? `<div class="footer-col"><h4>Services</h4><ul>${serviceLinks}</ul></div>` : ''}
        ${quickLinks ? `<div class="footer-col"><h4>Quick Links</h4><ul>${quickLinks}</ul></div>` : ''}
        <div class="footer-col" style="display:none;">
          <h4>Contact</h4>
          <ul>${contactItems}</ul>
        </div>
      </div>
      <div class="footer-bottom">
        <p>${footer.legal || '© 2026 Antiopix. All rights reserved.'}</p>
        <div class="footer-links">
          <a href="${privacyHref}">Privacy Policy</a>
          <a href="${termsHref}">Terms of Service</a>
        </div>
      </div>
    </footer>
  `;
  footerContainer.innerHTML = footerHTML;
}



